import { httpClient } from '@/infra/protocols/http';

export async function regenerateScriptItem(
  params: RegenerateScriptItemService.Params,
  data: RegenerateScriptItemService.Payload,
): Promise<RegenerateScriptItemService.Response> {
  const body = {
    prompt: data.prompt,
    historico: data.history?.map((h) => ({ prompt: h.prompt, resultado: h.result })),
  };

  const response = await httpClient.post<RegenerateScriptItemService.Data>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}/roteiro/blocos/${params.blockId}/regerar`,
    body,
  );

  return {
    result: response.texto,
  };
}

export namespace RegenerateScriptItemService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: string;
    blockId: number;
  }

  export type Payload = {
    prompt: string;
    history?: {
      prompt: string;
      result: string;
    }[];
  };

  export type Data = {
    texto: string;
  };

  export type Response = {
    result: string;
  };
}
